import { useFieldActions } from '../../contexts/field-actions-context';
export const useUploadFile = () => {
  const {
    actions,
    formId
  } = useFieldActions();
  return async (filesToUpload, onDone, onError) => {
    if (!(actions != null && actions.uploadFile) || !filesToUpload.length) {
      if (!(actions != null && actions.uploadFile)) {
        console.error('No uploadFile action');
      }
      if (!filesToUpload.length) {
        console.error('No files to upload');
      }
      return [];
    }
    const uploadTasks = filesToUpload.map(_ref => {
      let {
        file
      } = _ref;
      return actions.uploadFile({
        file,
        formId
      }).then(fileDescriptor => {
        const {
          id,
          displayName,
          url
        } = fileDescriptor;
        onDone(file);
        return {
          fileId: id,
          displayName: displayName || file.name,
          url: url || '',
          fileType: file.type
        };
      }).catch(_e => {
        onError(_e, file);
      });
    });
    const uploadedValues = await Promise.all(uploadTasks);
    return uploadedValues.filter(v => v !== undefined);
  };
};
//# sourceMappingURL=use-upload-file.js.map